import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const index = () => import('./main.vue')


const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        level: 'a1',
        title: '摇钱花',
        report: {
          eventName: 'zhuceluodiye_shurushoujihaoye',
        },
      },
      component: index,
    },
    {path: '/*', redirect: '/'},
  ],
  scrollBehavior: () => ({y: 0}),
})
export default router




// WEBPACK FOOTER //
// ./src/module/blueRegPage/index/router.js